<template>
    <div class="modal" tabindex="-1" role="dialog" id="modal-approve-list" v-if="project">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{project.id}} - {{project.alias}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-6">
                             <table class="table table-sm">
                                <tr>
                                    <td>Estatus de aprobación</td>
                                    <td>
                                        <span class="label" 
                                            v-if="!approved_status_mode_edit"
                                            v-on:dblclick="approved_status_mode_edit = !approved_status_mode_edit"
                                            v-bind:style="{ background: project.approved_status_data['color'], color: '#FFF' }">
                                            {{project.approved_status_data["text"]}}
                                        </span>
                                        <select class="form-control"
                                            v-model="project.approved_status"
                                            @change="editStatus()"
                                            v-if="approved_status_mode_edit">
                                            <option value="0">NA</option>
                                            <option value="1">Harán o ya hicieron el pago inicial.</option>
                                            <option value="2">Si quieren el crédito, están en proceso de conseguir el enganche o de conseguir algún tipo de autorización.</option>
                                            <option value="3">Volver a contactar.</option>
                                            <option value="4">Siguen en duda de aceptar el crédito.</option>
                                            <option value="5">No quieren el crédito.</option>
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Último Seguimiento</td>
                                    <td>{{project.last_followup_date || 'Sin seguimiento'}}</td>
                                </tr>
                                <tr>
                                    <td>Teléfono contacto</td>
                                    <td>{{project.client.fiscal.phone}}</td>
                                </tr>
                                <tr>
                                    <td>Email contacto</td>
                                    <td>{{project.client.user.email}}</td>
                                </tr>
                                <tr>
                                    <td>F. aceptación crédito</td>
                                    <td>{{project.finance.credit_acceptance_date || 'Sin aceptación'}}</td>
                                </tr>
                                <tr>
                                    <td>Días restantes Ficha</td>
                                    <td v-if="payment_card != null">
                                        <span class="label" v-bind:class="{'label-status-9': (payment_card.expiration_days <= 0), 'label-status-2': (payment_card.expiration_days > 0)}" v-if="payment_card.expiration_days > 0">
                                            {{payment_card.expiration_days}}  días
                                        </span>
                                        <a :href="payment_card.initial_payment_url" target="_blank" data-toggle="tooltip" data-placement="right" title="Abrir ficha de pago" v-if="payment_card.expiration_days > 0">
                                            <em class="fas fa-file-invoice-dollar"></em>
                                        </a>
                                        <span class="label label-status-9" v-if="payment_card.expiration_days <= 0 && payment_card.expiration_days != null">
                                            Ficha expirada
                                        </span>
                                        <span class="label label-status-warning" v-if="payment_card.expiration_days == null">
                                            Sin ficha
                                        </span>
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div class="col-md-6">
                            <message-log
                                    ref="messageLogBox"
                                    :autobinding="false"
                                    :project_id="project.id"/>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <router-link :to="`project/${project.id}`" class="btn btn-primary btn-raised">Ir al proyecto</router-link>
                    <button type="button" class="btn btn-warning" @click="generateCardPayment()" v-if="payment_card.expiration_days <= 0">Generar nueva ficha</button>
                    <button type="button" class="btn btn-secondary" @click="close()">Cerrar</button>
                </div>
            </div>
        </div>

        <new-cardpayment-modal
                ref="ncp_modal"
                :project_id="project"
                v-on:onGenerate="generateNewCardPayment()"/>
    </div>
</template>
<script>
let MessageLog = require("../../views/admin/projects/process-flow/message-log").default;
let NewCardpaymentModal = require("../../views/admin/projects/process-flow/new-cardpayment-modal").default;

export default {
    data() {
        return {
            project: null,
            payment_card: {
                expiration_days: 0
            },
            isLoaded: false,
            approved_status_mode_edit: false,
        }
    },
    beforeUpdate() {
        $('[data-toggle="tooltip"]').tooltip();
    },
    components: {
        'message-log': MessageLog,
        NewCardpaymentModal
    },
    methods: {
        close() {
            $("#modal-approve-list").modal("hide");
        },
        async editStatus(status) {
            this.approved_status_mode_edit = false;
            try {
                let res = await axios.put(`/api/project/${this.project.id}/approved_status`, {
                    approved_status: this.project.approved_status
                });
                this.project.approved_status_data['text'] = res.data.approved_status_data['text']
                this.project.approved_status_data['color'] = res.data.approved_status_data['color']
            } catch (ex) {
                console.log(ex)
                swal("Upss!", "Hubo un error al modificar el status.", "error")
            }
        },
        generateCardPayment() {
            this.$refs.ncp_modal.show()
        },
        generateNewCardPayment(res) {
            this.payment_card.initial_payment_url = res.initial_payment_url
            this.payment_card.expiration_date = res.expiration_date
        },
        async show(id) {
            try {
                $("#modal-approve-list").modal("show");
                
                let res = await axios.get(`/api/project/${id}`)
                this.project = res.data
                this.isLoaded = true

                let pc_res = await axios.get(`/api/project/${id}/payment_card`)
                this.payment_card = pc_res.data;
                //actualizar caja de mensajes
                this.$refs["messageLogBox"].getNotes();
            } catch (err) {
                console.log(err)
            }
        }
    }
}
</script>